import { useSelector } from 'react-redux';
import { getUrlPrefix } from '@app/redux/localization/selectors';

/**
 * @deprecated
 * @see useUrlBuilder
 */
const useUrlPrefix = () => useSelector(getUrlPrefix);

export default useUrlPrefix;
